import React, { useRef, useState } from "react";
import {
    useFloating,
    offset,
    flip,
    shift,
    autoUpdate,
    useClick,
    useDismiss,
    useRole,
    FloatingPortal,
    useInteractions
} from "@floating-ui/react";
import { useDispatch } from "react-redux";
import AddToPlaylist from "./AddToPlaylist";
import { crossIcon } from "../../../Assets/svg";
import { useTranslation } from 'react-i18next';


const ThreeDotsSvg = ({ open }) => {
    return (
        <svg width={30} height={15} id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.85 74.81">
            <g id="Layer_1-2" data-name="Layer 1">
                <g>
                    <circle style={{ fill: open ? "#f7ba31" : "#fff" }} cx="6.92" cy="6.92" r="6.92" />
                    <circle style={{ fill: open ? "#f7ba31" : "#fff" }} cx="6.92" cy="37.41" r="6.92" />
                    <circle style={{ fill: open ? "#f7ba31" : "#fff" }} cx="6.92" cy="67.89" r="6.92" />
                </g>
            </g>
        </svg>
    )
}

const AddToPlaylistButton = ({ config, onChange }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    // 🔹 Dropdown state
    const [open, setOpen] = useState(false);
    const [subOpen, setSubOpen] = useState(false);

    // 🔹 Floating UI setup for smart positioning
    // Main Menu
    const { refs, floatingStyles, context } = useFloating({
        placement: "bottom-start", // default placement (bottom right of trigger)
        middleware: [offset(0), flip(), shift(10)], // auto adjust if no space
        whileElementsMounted: autoUpdate, // auto-update on scroll/resize
        open,
        onOpenChange: setOpen,
        strategy: "fixed", // prevents clipping inside parent with overflow
    });

    // 🔹 Handle outside clicks & escape key to close dropdown
    const click = useClick(context);
    const dismiss = useDismiss(context);
    const role = useRole(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role]);

    // Submenu

    // Submenu floating setup
    const {
        refs: subRefs,
        floatingStyles: subFloatingStyles,
        context: subContext,
    } = useFloating({
        open: subOpen,
        onOpenChange: setSubOpen,
        placement: "right-start",
        middleware: [offset(0), flip(), shift({ padding: 0 })],
        whileElementsMounted: autoUpdate,
    });

    // 🔹 Handle outside clicks & escape key to close dropdown
    const subClick = useClick(subContext);
    const subDismiss = useDismiss(subContext);
    const subRole = useRole(subContext);
    const { getReferenceProps: getSubRefProps, getFloatingProps: getSubFloatingProps } = useInteractions([subClick, subDismiss, subRole]);


    const handleOnChange = (event) => {
        setOpen(false);
        onChange({
            event: event,
            id: config?.id
        });
    }

    return (
        <>

            {/* 3-dot button (dropdown trigger) */}
            <button
                ref={refs.setReference}
                {...getReferenceProps()}
                className="add-playlist-btn btn-transparent py-2"
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen((prev) => !prev);
                }}
            >
                <ThreeDotsSvg open={open} />
            </button>

            {/* Dropdown menu (portal ensures no clipping) */}
            {open && (
                <FloatingPortal>
                    <div
                        ref={refs.setFloating}
                        {...getFloatingProps()}
                        className="dropdown-menu show p-0"
                        style={{
                            ...floatingStyles,
                            backgroundColor: "#03254c",
                            // left: 10,
                            color: "white",
                            borderRadius: "8px",
                            padding: "10px",
                            minWidth: "250px",
                            zIndex: 999,
                            overflow: 'hidden',
                        }}
                    >
                        {
                            !config.isSavedPlaylist ? (
                                <>

                                    {/* Submenu trigger */}
                                    <div
                                        ref={subRefs.setReference}
                                        {...getSubRefProps()}
                                    >
                                        <div className="mixerHeader flex-shrink-0 mb-2">
                                            <h3>{t("playlists.addToPlaylist")}</h3>
                                            <div className="text-end d-flex align-items-center gap-2">
                                                <button className="notButton d-flex align-items-center ms-1" onClick={() => setOpen(false)} >
                                                    <img src={crossIcon} alt="Close Button" />
                                                </button>
                                            </div>
                                        </div>
                                        <AddToPlaylist config_list={config} />
                                    </div>

                                    {/* Submenu content */}
                                    {/* <FloatingPortal>
                                        {subOpen && (
                                            <div
                                                ref={subRefs.setFloating}
                                                style={{
                                                    ...subFloatingStyles, // keep Floating UI positioning
                                                    backgroundColor: "#03254c",
                                                    borderRadius: "4px",
                                                    zIndex: 9,
                                                }}
                                                {...getSubFloatingProps()}
                                                className="text-white shadow p-2"
                                            >
                                                <AddToPlaylist config_list={config} onSuccess={handleSuccessModal} />
                                            </div>
                                        )}
                                    </FloatingPortal> */}
                                </>
                            ) : (
                                <>
                                    <button
                                        className="dropdown-item text-white d-flex align-items-center gap-2 py-2"
                                        style={{ backgroundColor: "transparent" }}
                                        onClick={() => handleOnChange('edit-playlist')}
                                    >
                                        {t("playlists.editPlaylist")}
                                    </button>
                                    {!config.system_created_playlist && (
                                        <button
                                            className="dropdown-item text-white d-flex align-items-center gap-2 border-top py-2"
                                            style={{ backgroundColor: "transparent" }}
                                            onClick={() => handleOnChange('remove-playlist')}
                                        >
                                            {t("playlists.removePlaylist")}
                                        </button>
                                    )}
                                    {/* {!config.system_created_playlist && ( */}
                                        <button
                                            className="dropdown-item text-white d-flex align-items-center gap-2 border-top py-2"
                                            style={{ backgroundColor: "transparent" }}
                                            onClick={() => handleOnChange('share-playlist')}
                                        >
                                            {t("playlists.sharePlaylist")}
                                        </button>
                                    {/* )} */}
                                    <button
                                        className="dropdown-item text-white d-flex align-items-center gap-2 border-top py-2"
                                        style={{ backgroundColor: "transparent" }}
                                        onClick={() => handleOnChange('add-to-mixes')}
                                    >
                                        {t("playlists.addToMyMixes")}
                                    </button>
                                </>
                            )
                        }

                    </div>
                </FloatingPortal>
            )}

        </>
    );
};

export default AddToPlaylistButton;

